import { render } from "./OutputForm.vue?vue&type=template&id=5f27642c"
import script from "./OutputForm.vue?vue&type=script&lang=js"
export * from "./OutputForm.vue?vue&type=script&lang=js"
script.render = render

export default script